module.exports = __webpack_public_path__ + "static/sportovni-den-2022-a2a8f5343683c5b8279e30d83ec65a33.jpg";